//
//
//
//
//

export default {
  name: 'ft-feedback',
  props: {
    title: String
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/Feedback.vue